import { Tag as AntTag } from 'antd';
import { TagProps as AntTagProps } from 'antd/lib/tag';
import cx from 'classnames';
import styles from './TagFeedback.module.less';

export type TagFeedbackStatus = 'success' | 'information' | 'warning' | 'error';

export interface TagFeedbackProps extends AntTagProps {
  status?: TagFeedbackStatus;
  children?: React.ReactNode;
}

export function TagFeedback({ status, className, children, ...otherProps }: TagFeedbackProps) {
  const statusClass = status ? styles[status] : undefined;
  return (
    <AntTag className={cx(statusClass, className)} {...otherProps}>
      {children}
    </AntTag>
  );
}

export default TagFeedback;
